<template>
  <span
    class="inline-flex min-h-6 items-center whitespace-nowrap rounded-full px-3 py-1 text-xs font-semibold"
    :class="extraClasses"
  >
    <slot name="icon" />
    <slot>
      {{ label }}
    </slot>
  </span>
</template>

<script>
export default {
  props: {
    label: {
      type: [Boolean, String],
      required: false,
    },

    extraClasses: {
      type: [Array, String],
      required: false,
    },
  },
}
</script>
